export default __webpack_public_path__ + "static/media/romi-noymark.7411554a.png";